import { inject, Ref } from 'vue';
export const fullLayoutStateSymbol = Symbol('fullLayoutState');
export interface FullLayoutState {
  fullLayoutRef: Ref<HTMLElement | null>;
}
export const useFullLayoutState = (): FullLayoutState => {
  const state = inject<FullLayoutState>(fullLayoutStateSymbol);
  return state;
};
